import React, { useState, useMemo, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts'; 
import { getInspection } from '../../../Inspection/services/inspectionsApi'; 
import { useQuery } from 'react-query';
import cloudImg from '../../../../assets/images/Group 70.png'; 
import { Row, Col, CardBody, CardHeader, Card } from 'reactstrap';
import { Spin } from 'antd';
import '../../utils/style.css';
import { useTranslation } from 'react-i18next';

const InspectionType = () => {
  const { isLoading, isError, error, data: allInspections = [] } = useQuery("inspections", getInspection);
  const inspections = allInspections?.filter(insp => insp.typeInspection !== "Incident");

  const { categories, counts } = useMemo(() => {
    const categoryCounts = inspections.reduce((acc, inspection) => {
      const category = inspection?.category;
      if (category) {
        acc[category] = (acc[category] || 0) + 1; 
      }
      return acc;
    }, {});
    const categories = Object.keys(categoryCounts); 
    const counts = Object.values(categoryCounts);
    return { categories, counts };
  }, [inspections]);

  const colors = ['#174F25', '#54C571', '#3D8C51'];  

  const [state, setState] = useState({
    series: counts,  
    options: {
      chart: {
        width: 300,
        type: 'pie', 
      },
      labels: categories,
      colors: colors, 
      legend: {
        show: false,  
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,  
          },
        },
      }],
    },
  });
const {t}=useTranslation();
  useEffect(() => {
    if (categories.length > 0 && counts.length > 0) {
      setState(prevState => ({
        ...prevState,
        series: counts,
        options: {
          ...prevState.options,
          labels: categories,
        }
      }));
    }
  }, [categories, counts]);

  return (
      <Card style={{ borderRadius: '15px' }}>
      <CardHeader>
        <Row>
          <Col md={9}>
            <div className="card-header-subtitle">
            {t("dashboard.typeIncident")} ({inspections?.length || "0"})
            </div>
          </Col>
          <Col md={3}>
            <img src={cloudImg} alt="img" style={{ width: '55px' }} />
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <span className="loading-text">{t("dashboard.chargement")} <Spin /></span>
        ) : isError ? (
          <span className="loading-text" style={{ color: 'red' }}>
           {t("dashboard.error")} 
          </span>
        ) :(
          <Row>
            <Col md={5}>
              <div>
                {categories.map((category, index) => {
                  const percentage = ((counts[index] * 100) / counts.reduce((a, b) => a + b, 0)).toFixed(1);
                  return (
                    <div key={index} className="category-item">
                      <div 
                        className="category-icon"
                        style={{ backgroundColor: colors[index] }}
                      ></div>
                      <span className="category-text">
                        {category} ({percentage}%)
                      </span>
                    </div>
                  );
                })}
              </div>
            </Col>

            <Col md={7} className="chart-container">
              <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="pie" width={200} />
              </div>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default InspectionType;
